import React from 'react';
import Box from '@mui/material/Box';
import { IAllChatsDetailListItemProps } from '../../../../../types/contentType';
import './AllChatsDetailListItem.scss';

const AllChatsDetailListItem: React.FC<IAllChatsDetailListItemProps> = ({
  title,
  icon,
  value = '',
  renderValue,
  onClick,
  detailListItemClass,
  valuePostfix = '',
  ...props
}) => {
  return (
    title || renderValue || value ? (
      <Box className={`eventDetailListItem ${detailListItemClass || ''}`}>
        <Box className="eventDetailListItemHold">
          {title && <span className="eventDetailListItemTitle">{title}</span>}
          {renderValue ? (
            renderValue()
          ) : (
            <Box className="eventDetailListItemTextHold">
              {/* {icon && <span className="eventDetailListItemIconHold">{icon}</span>} */}
              <small className="eventDetailListItemValue">
                {value}
                {valuePostfix}
              </small>
            </Box>
          )}
        </Box>
      </Box>
    ) : null
  );
};

export default AllChatsDetailListItem;
